import { Component, Input, OnInit } from '@angular/core';
import { CourseStartDate } from '../../../models/pricelist-course-start-date.model';
import { CourseStartDatesTableLabels } from '../../../models/types';
import { getCourseStartDatesLabels } from '../../../utils/table-utils';
import { CompanyEnum } from '../../../models/company.model';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';

@Component({
  standalone: true,
  imports: [CommonModule, TableModule],
  selector: 'lx-price-lists-portal-positively-languages-course-start-dates',
  templateUrl: './positively-languages-course-start-dates.component.html',
  styleUrls: ['./positively-languages-course-start-dates.component.scss'],
})
export class PositivelyLanguagesCourseStartDatesComponent implements OnInit {
  @Input() courseStartDates: CourseStartDate[] = [];

  columnLabels: CourseStartDatesTableLabels | undefined;

  KIL = CompanyEnum.KIL;

  ngOnInit(): void {
    this.columnLabels = getCourseStartDatesLabels(this.KIL);
  }
}
